import React, { useRef, useCallback, useEffect } from 'react'
import { Button } from 'antd'
import { Input } from '@/ui'

import Upload from './Upload'
import styles from './File.less'

const File = ({ value, onChange, ...restProps }) => {
    const $this = useRef({
        value
    })
    const $upload = useRef(null)

    useEffect(() => {
        return () => {
            const { value } = $this.current

            if (Array.isArray(value)) {
                value.forEach(v => v && v.uploadTask && v.uploadTask.abort())
            } else {
                value && value.uploadTask && value.uploadTask.abort()
            }
        }
    }, [])

    const btnProps = {
        value,
        onChange,
        ...restProps
    }

    const handleSelect = useCallback(() => {
        $upload.current && $upload.current.select()
    }, [])

    return (
        <Input.Group compact>
            <Input
                readOnly
                style={{ width: '80%' }}
                className={styles.input}
                value={value && value.status === 'done' ? value.url : undefined}
            />
            <Button onClick={handleSelect} loading={value && value.status === 'uploading'}>
                上传
            </Button>
            <Upload ref={$upload} {...btnProps} />
        </Input.Group>
    )
}

File.defaultProps = {
    multiple: false,
    autoPreview: false
}

export default File
